export const activeSideNav = "border-r-2 border-blue-600  bg-[#00325d] text-white border-b-transparent";
